import { render } from "./PollsManagement.vue?vue&type=template&id=0f5fc173&scoped=true"
import script from "./PollsManagement.vue?vue&type=script&lang=js"
export * from "./PollsManagement.vue?vue&type=script&lang=js"

import "./PollsManagement.vue?vue&type=style&index=0&id=0f5fc173&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5fc173"]])

export default __exports__